<script setup>
import { computed } from 'vue';
import { Handle, Position } from '@vue-flow/core';
import { useStoreGetters } from 'dashboard/composables/store';
import { NODE_TYPES } from '../../constants';
import FlowNodeCard from './FlowNodeCard.vue';

const props = defineProps({
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});
const meta = NODE_TYPES.transfer_human;
const getters = useStoreGetters();
const teamName = computed(() => {
  if (!props.data.team_id) return '';
  return getters['teams/getTeamById'].value(props.data.team_id)?.name || '';
});
</script>

<template>
  <FlowNodeCard :icon="meta.icon" :color="meta.color" :title="meta.label" :selected="selected">
    <Handle type="target" :position="Position.Left" />
    <p>Encerra o fluxo e passa pra um atendente.</p>
    <p v-if="data.label" class="mt-1 text-n-slate-9">Assunto: {{ data.label }}</p>
    <p v-if="teamName" class="mt-1 text-n-slate-9">Fila: {{ teamName }}</p>
  </FlowNodeCard>
</template>
